// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IOrgMember {
	id: string | undefined;

	firstName: string | undefined;

	lastName: string | undefined;

	name: string | undefined;

	$type?: string | undefined;
}
export class OrgMember {
	constructor(data?: IOrgMember) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	id: string | undefined;

	firstName: string | undefined;

	lastName: string | undefined;

	name: string | undefined;

	static $type: string = "CoreApi.Models.OrgMember, ";
	$type?: string | undefined = OrgMember.$type;
}

